import { z } from 'zod';
import type { FocusGroupResponseDto } from '@inference.engine/persona-api-client';

const BrandContextSchema = z.object({
  brandName: z.string().nullable(),
  applied: z.boolean(),
});

export type FocusGroupBrandContext = z.infer<typeof BrandContextSchema>;

/** Null for a focus group run before this field existed, or one started outside IQ. */
export const getBrandContext = (
  focusGroup: FocusGroupResponseDto,
): FocusGroupBrandContext | null => {
  const parsed = BrandContextSchema.safeParse(focusGroup.brandContext);
  return parsed.success ? parsed.data : null;
};
